import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import style from "./product-description-details.css";
import ReadMoreLess from "../../read-more-less/read-more-less";

function ProductDescriptionDetails({ productDescription, productTitle, className }) {
    return (
        <div className={classnames(className, style.detailsHolder)}>
            <h4 className={style.detailsTitle}>{productTitle}</h4>
            <ReadMoreLess
                readMore={gettext("general.see_more")}
                readLess={gettext("general.see_less")}
                text={productDescription}
                itemAttributes={{ itemProp: "description" }}
            />
        </div>
    );
}

ProductDescriptionDetails.propTypes = {
    productDescription: PropTypes.string.isRequired,
    productTitle: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default ProductDescriptionDetails;
